<div class="submit-event-form" (keydown.enter)="$event.preventDefault()" #container>
    <img *ngIf="!isScrolledEnd" [src]="downwardArrow" matTooltip="scroll down to submit your event" alt=""
        style="position:fixed;z-index:99;bottom: 10%;left:45%;width: 100px;height:100px">

    <div class="create-event-header">
        <div headerTitle>Add Events Manually</div>
        <span (click)="goBack()">
            <mat-icon>chevron_left</mat-icon>Back to events
        </span>
        <div style="color:orangered;margin-top: 16px">Complete all required fields marked with an * to submit your event
            for approval.</div>
    </div>
    <ig-row>
        <ig-col [xs]="12" [md]="7" [lg]="7" class="submit-event-fields">
            <ig-row>
                <ig-col [xs]="12" class="required">
                    <ig-field label="Event Title *" [isRequired]="true" icon="stars"
                        [formControl]="createEventForm.get('name')" [(ngModel)]="command.name">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12" class="required">
                    <ig-field label="Event Host *" [isRequired]="true" icon="person"
                        [formControl]="createEventForm.get('host')" [(ngModel)]="command.host">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <ig-field label="Location / Venue Name" icon="location_city"
                        [formControl]="createEventForm.get('venue')" [(ngModel)]="command.venue">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12" class="required">
                    <ig-address-input [label]="addressInputLabel"
                        label2="Start typing the physical address and select from a verified Google Maps address below"
                        matTooltip="please type and select an address from the dropdown" [(ngModel)]="command.address"
                        [formControl]="createEventForm.get('address')">
                    </ig-address-input>

                    <span *ngIf="isAllowOnlineEvents" class="m-r-3">
                        <mat-checkbox data-testid="virtual-event" class="m-b-3" [(ngModel)]="command.isOnlineEvent"
                            (change)="virtualEventChange()">Virtual Event</mat-checkbox>
                        <mat-icon style="color:lightgray"
                            matTooltip="Virtual events don't have physical addresses">info</mat-icon>
                    </span>

                    <mat-checkbox class="m-b-3" [(ngModel)]="command.isHybridEvent"
                        (change)="hybridEventChange()">Hybrid Event</mat-checkbox>
                    <mat-icon style="color:lightgray"
                        matTooltip="Hybrid events are both virtual and in-person">info</mat-icon>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12" class="relative">
                    <mat-checkbox name="GDPREmail" class="m-b-3" [(ngModel)]="isEmailGDPRAllowed"
                        style="position: absolute;top: 18px;z-index: 2"></mat-checkbox>
                    <ig-field #inputElement label="Event Organizer Email Address"
                        label2="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I understand and agree that this email will only be used for admin purposes, in case we need to contact you about your event. It will not be displayed publicly in your event listing. No additional user data is tracked or stored. We pride ourselves on having a 100% GDPR-compliant SaaS and our content distribution services are built with privacy in mind from the bottom and up."
                        [isRequired]="false" [disabled]="!isEmailGDPRAllowed" icon="mail"
                        [formControl]="createEventForm.get('organizerEmail')" [(ngModel)]="command.organizerEmail">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <ig-field label="Event URL for more information (if applicable)" icon="link"
                        [formControl]="createEventForm.get('eventLink')" [(ngModel)]="command.eventLink">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <ig-field label="Event Host Website URL" icon="link" [formControl]="createEventForm.get('hostLink')"
                        [(ngModel)]="command.hostLink">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <ig-field label="Get Tickets URL (if applicable)" icon="receipt"
                        [formControl]="createEventForm.get('ticketUri')" [(ngModel)]="command.ticketUri">
                    </ig-field>
                </ig-col>
            </ig-row>
            <ig-row>
                <ig-col [xs]="12">
                    <mat-form-field class="text-area">
                        <textarea #description matInput placeholder="Event Description" type="textArea"
                            [(ngModel)]="command.description" (input)="descriptionChange()"
                            [formControl]="createEventForm.get('description')">
                        </textarea>
                    </mat-form-field>
                </ig-col>
            </ig-row>

            <ig-row>
                <ig-col [xs]="12" class="m-t-3">
                    <div class="flex time-input relative" *ngFor="let timeRange of command.eventTimes;let i=index">
                        <div style="flex: 12">
                            <div style="position: absolute;top:-12px;left:0;color:#99abb4">From</div>
                            <!--                            <div style="position: absolute;top:-12px;color:#99abb4"-->
                            <!--                                 [ngStyle]="{'left':command.frequency!=='custom'?'42%':'45%'}">To-->
                            <!--                            </div>-->
                            <div style="position: absolute;color:#99abb4"
                                [ngStyle]="{'left':isMobile?'0':command.frequency!=='custom'?'46%':'45%','top':isMobile?'50px':'-12px'}">
                                To
                            </div>
                            <ig-datetime-input #dateTimeInput [frequency]="command.frequency" [allowNoTime]="true"
                                [startDate]="command.eventTimes[i].startTime" [endDate]="command.eventTimes[i].endTime"
                                [timezone]="command.timezone" (change)="setEventTime($event, command.eventTimes[i])">
                            </ig-datetime-input>
                        </div>
                        <!--                        <div style="flex: 1" matTooltip="change timezone" class="timezone"-->
                        <!--                             [class.center]="command.frequency!=='custom'"-->
                        <!--                             [class.timezone-pos]="command.frequency!=='custom'" (click)="showTimezoneCitySelector=true">-->
                        <!--                        <div style="flex: 1" matTooltip="change timezone" class="timezone">-->
                        <!--                            <div>-->
                        <!--                                <span-->
                        <!--                                    *ngIf="!isLoadingTimezone&&hasSetTimezone">{{command.timezone}}</span>-->
                        <!--                                <span *ngIf="!isLoadingTimezone&&!hasSetTimezone">Timzeone</span>-->
                        <!--                                <mat-spinner *ngIf="isLoadingTimezone" [diameter]="26" [strokeWidth]="3"-->
                        <!--                                             style="margin:auto"></mat-spinner>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <div *ngIf="command.frequency==='custom'" class="time-plus">
                            <ig-button *ngIf="!i" (trigger)="addTimeRange()" matTooltip="Add more dates">+</ig-button>
                            <ig-button *ngIf="i" (trigger)="removeTimeRange(i)" color="cancel"
                                matTooltip="Remove this date">-</ig-button>
                            <!--                            <mat-icon *ngIf="!i" (click)="addTimeRange()" matTooltip="add more dates">add</mat-icon>-->
                            <!--                            <mat-icon *ngIf="i" (click)="removeTimeRange(i)" matTooltip="remove this date">remove</mat-icon>-->
                        </div>
                    </div>


                </ig-col>
            </ig-row>

            <ig-row class="relative timezone-frequency">
                <ig-col [xs]="6">
                    <ig-city-selector type="text" [label]="timezoneLabel" [(ngModel)]="timezoneAddress"
                        [isRequired]="false" (onAddressClear)="resetTimezoneLabel()" [disabled]="!manualSetTimezone"
                        (ngModelChange)="citySelected()"
                        [formControl]="createEventForm.get('timezone')"></ig-city-selector>
                    <a *ngIf="!manualSetTimezone"
                        (click)="manualSetTimezone=true;timezoneLabel='Enter a city to set timezone'">
                        <span *ngIf="!isMobile">change timezone</span>
                        <mat-icon *ngIf="isMobile" style="margin-top: -8px">edit</mat-icon>
                    </a>
                </ig-col>
                <!--                <ig-col [xs]="2" style="line-height: 60px;text-align: center">-->
                <!--                    <div>-->
                <!--                        <span *ngIf="!isLoadingTimezone&&hasSetTimezone">{{command.timezone.replace('D', 'S')}}</span>-->
                <!--                        <span *ngIf="!isLoadingTimezone&&!hasSetTimezone">Timezone</span>-->
                <!--                        <mat-spinner *ngIf="isLoadingTimezone" [diameter]="26" [strokeWidth]="3"-->
                <!--                                     style="margin: -10px auto auto 20px;"></mat-spinner>-->
                <!--                    </div>-->
                <!--                </ig-col>-->
                <ig-col [xs]="6" style="padding-left: 12px">
                    <ig-select [(ngModel)]="frequencyItems" label="Frequency" (onOpen)="setFrequencyDropdown()"
                        (itemSelected)="frequencySourceChange($event)">
                    </ig-select>

                    <div *ngIf="totalTimes&&command.frequency!=='custom'" style="color:#99abb4;margin-bottom:22px">
                        <span><b>{{totalTimes.split('Dates')[0]}} Dates</b></span><span
                            style="margin-left: 16px">{{totalTimes.split('Dates')[1]}}</span>
                    </div>
                </ig-col>
            </ig-row>

            <ig-row>
                <ig-col [xs]="12">
                    <ig-image-selector [command]="command" [selectedImageData]="resizeImageTemp"
                        label="Upload Event Image" [label2]="!isImageChanged?imageUploaderLabel2:''"
                        (onImageChanged)="onImageChange($event)" updateLabel="Update Event Image">
                    </ig-image-selector>
                    <ig-image-resize *ngIf="resizeImageTemp" [imageToResize]="resizeImageTemp"
                        (onImageResized)="imageResized($event)"></ig-image-resize>
                    <mat-checkbox *ngIf="isImageChanged" [(ngModel)]="hasCopyrights" class="m-t-1">Please note that any
                        images uploaded or used in this software must either be royalty-free or owned by the client. By
                        uploading or using an image, you acknowledge that you have the necessary rights to use it and
                        that you will be solely responsible for any copyright infringement or other legal issues that
                        may arise from the use of the image. We strongly advise our users to exercise due diligence and
                        ensure that they have the necessary rights to use any images uploaded or used in this software.
                    </mat-checkbox>
                </ig-col>
            </ig-row>
        </ig-col>
    </ig-row>
    <ig-row style="margin-bottom: 48px">
        <ig-col [xs]="12" [md]="7" [lg]="7">
            <ig-success-wrap #createEventSuccess [delay]="100" text="Your event has been submitted successfully!">
                <ig-button [isAsync]="true" [disabled]="isFormInvalid||(isImageChanged && !hasCopyrights)"
                    class="create-event-btn" size="md" color="accent" [style.max-width]="isMobile?'unset':'200px'"
                    (trigger)="createEvent($event)">
                    Create event
                </ig-button>
            </ig-success-wrap>

            <div *ngIf="submitSuccess" class="success-tip">
                Thank you for entering your event! It has been submitted for approval. Please allow up to 72 hours for
                this process to take place.
                <span (click)="submitSuccess=false">X</span>
            </div>

        </ig-col>
    </ig-row>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/create.event/create.event.component.html